import { memo, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';

import { Text } from '@fhs/ui';
import { useCartContext } from '@fhs-legacy/frontend/src/state/cart';
import { CHECKOUT_ORDER_SUMMARY_DISCOUNT } from '@fhs-legacy/frontend/src/utils/test-ids';

function DiscountRow() {
  const { serverOrder } = useCartContext();

  const discountAmount = useMemo(() => {
    const discounts = serverOrder?.cart?.discounts || [];
    return discounts.reduce((sum, d) => sum + d.value, 0);
  }, [serverOrder?.cart?.discounts]);

  if (!discountAmount || discountAmount === 0) {
    return null;
  }

  const formattedDiscount = (discountAmount / 100).toFixed(2);

  return (
    <View
      testID={CHECKOUT_ORDER_SUMMARY_DISCOUNT}
      style={[styles.container, { alignItems: 'center' }]}
      accessibilityRole="text"
      accessibilityLabel={`Discount: ${formattedDiscount}`}
    >
      <Text.Paragraph size="sm">Discount</Text.Paragraph>

      <Text.Ui testID={'discount-amount'} size="sm">
        - ${formattedDiscount}
      </Text.Ui>
    </View>
  );
}

export default memo(DiscountRow);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingBottom: 4,
    marginHorizontal: 28,
  },
});
